import { SxProps, Theme } from '@mui/material';

export interface IMap<T> {
  [key: string]: T;
}

export interface IOption<T = unknown> {
  value: T;
  label: string;
  disabled?: boolean;
  groupLabel?: string;
  name?: string;
  sx?: SxProps<Theme>;
}

export interface IOptionResponse {
  id: number;
  name: string;
}

export const hasIdProperty = <T extends object>(obj: T): obj is T & { id: string } => 'id' in obj;

export enum EDismissButtonTypes {
  DismissAll = 'Dismiss All',
  DismissSelected = 'Dismiss Selected',
}

export interface GroupUser {
	userId: string;
	userName: string;
}

export interface IAllUsers {
  groupUsers?: GroupUser[];
  rolesUsers?: IRoleUser[];
}

export enum ECheckType {
  Cut = 'check-cut',
  Void = 'check-void',
  Sent = 'check-sent',
  Requests = 'check-requests',
  Declined = 'check-declined',
  Undo = 'check-undo',
  ProductRequestsCut = 'product-check-requests-cut',
  ProductRequestsDeclined = 'product-check-requests-declined',
  ProductRequests = 'product-check-requests',
  ATRefundCheck = 'at-refund-check',
}

export interface IPeriod {
  id: string;
  name: string;
  year: number;
  fromDate: Date;
  toDate: Date;
  numericId: number;
}

export enum EStipTypeEntity {
  CONTACT = 'Contact',
  ASSET = 'Asset',
  DEAL = 'Deal',
}

export enum EViewType {
  FILES_TAB = 'filesTab',
  STIP_REQUEDST_MODAL = 'stipRequestModal'
}

export enum BorrowerType {
  Borrower = 1,
  CoBorrower = 2
}

export interface IStipType {
  name: string;
  relatedToEntity: EStipTypeEntity;
  isRequired: boolean;
  isRequiredFromCoBorrower: boolean;
  willComeFromCustomer: boolean;
  isReviewable: boolean;
  defaultNote: string;
  cp_Enabled: boolean;
  id?: string;
  isHidden: boolean;
}

export interface IUserBase {
  userId: string;
  userName: string;
  isExcluded?: boolean;
  isDeleted?: boolean;
  assignedFrom?: string;
}

export interface IRoleUser extends IUserBase {
  isIncluded: boolean;
}

export interface IUserData {
  isAdmin: boolean;
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  phoneExtension: string;
  isActive: boolean;
  isDeleted: boolean;
  phoneSystemUserId: number;
  trainingPeriodId: string;
  terminationDate: Date;
  officeLocationId: string;
  paySystemUserId: string;
  isAcumaticaRecordExist: boolean;
  numericId: number;
}

export interface IError {
  response: {
    status: number;
  }
}
